import TableVertical from "../Util/TableVertical";
import CardLayout from "../Layout/CardLayout";
import React, { useState, useEffect } from "react";
import Ranked from "../Ciem/Ranked";
import axiosInstance from "../../../api/api";

const InversionCapitalTrabajo = (ciemId) => {
    const [rankedForm, setRankedForm] = useState([]);

    useEffect(() => {
        axiosInstance.get('/detailoption/option/value/rankedNine').then((response) => {
            console.log("Calificación obtenida:", response.data.data[0]);
            setRankedForm(response.data.data[0]);
        }).catch((e) => {
            alert("Error consultando la calificacion " + e)
        });
    }, []);

    const contributionForm =
        <TableVertical optionName={"inversionCapitalTrabajoTable"}
                       ciemId={ciemId}
                       editable={true}
        />
    ;

    const calificacion = <Ranked field={rankedForm} ciemId={ciemId.ciemId} />

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionCapitalTrabajoTitulo"} tablaComponent={contributionForm} />
            <CardLayout value={"rankedNine"} tablaComponent={calificacion} />
        </div>
    );
};
export default InversionCapitalTrabajo;